'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MockedDOMSource = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mockDOMSource = mockDOMSource;

var _most = require('most');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MockedDOMSource = exports.MockedDOMSource = function () {
  function MockedDOMSource(_mockConfig) {
    _classCallCheck(this, MockedDOMSource);

    this._mockConfig = _mockConfig;
    if (_mockConfig['elements']) {
      this.elements = _mockConfig['elements'];
    } else {
      this.elements = (0, _most.empty)();
    }
  }

  _createClass(MockedDOMSource, [{
    key: 'events',
    value: function events(eventType) {
      var mockConfig = this._mockConfig;
      var keys = Object.keys(mockConfig);
      var keysLen = keys.length;
      for (var i = 0; i < keysLen; i++) {
        var key = keys[i];
        if (key === eventType) {
          return mockConfig[key];
        }
      }
      return (0, _most.empty)();
    }
  }, {
    key: 'select',
    value: function select(selector) {
      var mockConfig = this._mockConfig;
      var keys = Object.keys(mockConfig);
      var keysLen = keys.length;
      for (var i = 0; i < keysLen; i++) {
        var key = keys[i];
        if (key === selector) {
          return new MockedDOMSource(mockConfig[key]);
        }
      }
      return new MockedDOMSource({});
    }
  }]);

  return MockedDOMSource;
}();

function mockDOMSource(mockConfig) {
  return new MockedDOMSource(mockConfig);
}


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/mockDOMSource.js
 **/